import 'proxy-polyfill/proxy.min.js'; // Proxy polyfill for IE 11
import {EPIC_TRACKING_UUID_PARAM, EPIC_TRACKING_UUID} from './constants';
import qs from 'query-string';
/**
 * In order to let user import and use window._epicTracking object that is loaded via tracking.js
 * A Proxy interceptor is used here to load wondow._epicTracking dynamically
 * It will try to find _epicTracking in window object whenever this module gets called.
 */

const handler = {
    get: (obj, prop) => {
        if (typeof window === 'undefined') throw new Error('epic-tracking is meant to be running in browser environment only');
        if (!window._epicTracking || typeof !window._epicTracking === 'object') {
            // Ad blocker prevents tracking.js from loading.
            console.error('Unable to find _epicTracking object in global, please make sure it is installed');
            if (['configure', 'trackEvent', 'registerHistoryEvent'].includes(prop)) {
                return () => {return false;};
            }
            return false;
        }
        return window._epicTracking[prop];
    }
};

const epicTracking = new Proxy({}, handler);

export default epicTracking;

/**
 * Append epicTid query parameter to the url for url based tracking (trackingv2)
 * Any redirection invoked by js using window.location is not dectable by tracking.js due to browser protection.
 * @param {*} url
 * @return {url} url
 */
export const trackJsRedirection = (inputUrl) => {
    let outputUrl = inputUrl;
    try {
        const {url, query} = qs.parseUrl(inputUrl);
        if (!query[EPIC_TRACKING_UUID_PARAM] && window[EPIC_TRACKING_UUID]) {
            query[EPIC_TRACKING_UUID_PARAM] = window[EPIC_TRACKING_UUID];
            outputUrl = `${url}?${qs.stringify(query)}`;
        } else {
            console.warn('unable to find trackingUUID from global state', window[EPIC_TRACKING_UUID], query[EPIC_TRACKING_UUID_PARAM]);
        }
    } catch (ex) {
        console.warn('Failed to track url due to:', ex);
    }

    return outputUrl;
};
